/**
 * Fleet Name Formatter.
 * @param {*} value
 * @param {*} row
 * @returns {*}
 */
window.fleetNameFormatter = function(value, row) {
    switch (row.type_id) {
        case TYPE_REEFER:
            if (rights.includes("reefers.show")) {
                return '<a href="/reefers/show/'+row.reefer_id+'">'+value+'</a>';
            } else {
                return value;
            }
        case TYPE_DRY_CONTAINER:
            if (rights.includes("dry_containers.show")) {
                return '<a href="/dry-containers/show/'+row.reefer_id+'">'+value+'</a>';
            } else {
                return value;
            }
        case TYPE_VEHICLE:
            if (rights.includes("vehicles.show")) {
                return '<a href="/vehicles/show/'+row.vehicle_id+'">'+value+'</a>';
            } else {
                return value;
            }
    }
};
